// Grace catch-up keeps the cadence rule_day; this line tells audits the task was created late.
export interface DaysLateSource {
  days_late?: number | null;
  rule_day?: number | null;
}

// "Created 1 day late (day-2 follow-up)"; '' when on time or the field is absent.
export function days_late_line(form: DaysLateSource | null | undefined): string {
  const late = form?.days_late;
  if (typeof late !== 'number' || !Number.isInteger(late) || late <= 0) return '';
  const text = `Created ${late} ${late === 1 ? 'day' : 'days'} late`;
  const day = form?.rule_day;
  return typeof day === 'number' && Number.isInteger(day) && day >= 0
    ? `${text} (day-${day} follow-up)`
    : text;
}
